<template>
  <div class="info">
      <h1>{{$t("main.termsOfUse.privacyPolicy")}}</h1>
      <h3>{{$t("main.termsOfUse.whatInfo")}}</h3>
      <p>{{$t("main.termsOfUse.whatInfoText")}}</p>

      <h3>{{$t("main.termsOfUse.whoCollecting")}}</h3>
      <p>{{$t("main.termsOfUse.whoCollectingText")}}</p>
      
      <h3>{{$t("main.termsOfUse.howCollected")}}</h3>
      <p>{{$t("main.termsOfUse.howCollectedText")}}</p>
      
      <h3>{{$t("main.termsOfUse.whyCollected")}}</h3>
      <p>{{$t("main.termsOfUse.whyCollectedText")}}</p>

      <h3>{{$t("main.termsOfUse.howUsed")}}</h3>
      <p>{{$t("main.termsOfUse.howUsedText")}}</p>

      <h3>{{$t("main.termsOfUse.whoShared")}}</h3>
      <p>{{$t("main.termsOfUse.whoSharedText")}}</p>

      <h3>{{$t("main.termsOfUse.whatEffects")}}</h3>
      <p>{{$t("main.termsOfUse.whatEffectsText")}}
      </p>

      <h3>{{$t("main.termsOfUse.individualsConcern")}}</h3>
      <p>{{$t("main.termsOfUse.individualsConcernText")}}</p>

      <h3>{{$t("main.termsOfUse.dataDeletion")}}</h3>
      <p>{{$t("main.termsOfUse.dataDeletionText")}}</p>

      <h3>{{$t("main.termsOfUse.legalStatement")}}</h3>
       <p>{{$t("main.termsOfUse.legalStatementText")}}</p>
  </div>
</template>

<script>
export default {
    name: "Termsofuse"
}
</script>

<style>

</style>